// removed by extract-text-webpack-plugin
module.exports = {"form-error":"FormError__form-error___8Yh-E"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Form/FormError.scss
// module id = 538
// module chunks = 0